'use client'

import { useEffect } from 'react'
import { hydrateReferral } from '../lib/hydrate-referral'

/**
 * Replays referral/advertiser attribution from the `pc_ref` cookie into localStorage, and
 * reports an Aiffiliate link's click once (lib/hydrate-referral.js).
 *
 * Rendered by the root layout OUTSIDE <LoadingIndicator>, and that placement is the point. This
 * used to run inside ClientHeaderWrapper, which sits inside the auth gate — so on an auth-gated
 * destination (e.g. `/a/create/<x>` → `/generate`) the header, and therefore the hydration, did
 * not mount until Firebase auth resolved. Out here it runs on first render of every page,
 * regardless of auth state, so the attribution is in localStorage before anything reads it.
 *
 * Renders nothing. hydrateReferral is idempotent (it never overwrites a stored affiliate and
 * reports each click once), so running it on every page, or twice, is harmless.
 */
export default function ReferralHydrator() {
  useEffect(() => {
    hydrateReferral()
  }, [])

  return null
}
